import React, { useContext } from "react";
import { FormProvider, useForm } from "react-hook-form";
import CSVInput from "components/shared/form/fields/CSVInput";
import RadioButton from "components/shared/form/fields/RadioButton";
import { each, omit } from "lodash";
import SharedInviteFields from "components/administration/invites/SharedInviteFields";
import FormActions from "components/shared/form/fields/FormActions";
import { ExternalInviteArgs } from "components/administration/invites/types";
import { NewInviteContext } from "components/administration/invites/NewInvitePage";
import InviteErrors from "components/administration/invites/InviteErrors";

type FormArgs = {
  csv: FileList;
  subject: string;
  body: string;
  character_encoding: string;
  user_type?: "normal" | "external";
};

export default function BatchExternalInviteForm({
  defaultValues,
  inviteExternal,
  errors,
}: ExternalInviteArgs) {
  const context = useContext(NewInviteContext);

  const methods = useForm<FormArgs>({
    defaultValues: {
      ...defaultValues,
      character_encoding: "ISO-8859-1",
    },
  });
  const { handleSubmit } = methods;

  function submit(data: FormArgs) {
    const body = new FormData();

    each(omit(data, ["csv", "character_encoding"]), (value, key) => {
      value && body.append(`external_invite[${key}]`, value);
    });

    body.append("csv", data.csv[0]);
    body.append("character_encoding", data.character_encoding);

    inviteExternal(body);
  }

  return (
    <FormProvider {...methods}>
      <form className="form-horizontal" onSubmit={handleSubmit(submit)}>
        <div className="text-muted my-4">
          {context === Preload.current_network
            ? I18n.t("js.invites.external_network_invites_hint")
            : I18n.t("js.invites.external_group_invites_hint")}
        </div>
        <div
          className="alert alert-info markdown-content prose text-sm"
          dangerouslySetInnerHTML={{
            __html: Application.markdown(I18n.t("js.invites.csv_hint_md")),
          }}
        />
        <InviteErrors {...errors} />
        <CSVInput
          name="csv"
          label={I18n.t("js.invites.csv_recipient_list")}
          required
        />
        <RadioButton
          name="character_encoding"
          label={I18n.t("js.invites.character_encoding")}
          options={[
            {
              label: I18n.t("js.invites.character_encoding_iso"),
              value: "ISO-8859-1",
            },
            {
              label: I18n.t("js.invites.character_encoding_utf"),
              value: "UTF-8",
            },
          ]}
          required
        />
        <SharedInviteFields />
        <FormActions
          saveText={I18n.t("js.invites.submit")}
          showCancel={false}
        />
      </form>
    </FormProvider>
  );
}
